
<ng-container [formGroup]="paymentOptionsForm">
    
    <ng-container *ngFor="let option of paymentOptions; let i = index; trackBy: trackByIndex" class="w-full mb-3">
        <p-card *ngIf="option.type" styleClass="flex w-full mb-3" >
            <div class="flex flex-row w-full justify-content-between">
                <div class="flex flex-row payment-option w-full align-items-center">
                    <p-radiobutton
                        ariaLabel="Payment option {{option.value}}"
                        [inputId]="option.value"
                        [value]="option.value"
                        formControlName="paymentOption"
                        data-auto-id="payment-option-radio"
                    />
                    <label [for]="option.value" class="ml-1">
                        <span
                            [attr.data-auto-id]="'payment-display-last-four-'+i"
                            *ngIf="option.value !== pazePaymentType && option.lastFour"
                            class="text-xs"
                        > 
                            {{option.lastFour}}
                        </span>&nbsp;&nbsp;
                        <span class="text-blue-700" *ngIf="option.value === pazePaymentType">{{option.value | titlecase}}</span>
                    
                        <img 
                            *ngIf="![bankTypeForUI, pazePaymentType].includes(option.type)"
                            [src]="option.image"
                            alt="Card logo"
                            class="h-1rem ml-1"
                        />
                        <i 
                            class="pi pi-building-columns ml-1"
                            *ngIf="option.type === bankTypeForUI && option.type !== pazePaymentType"
                        ></i>
                    </label>
                </div>
                
                <p-button
                    *ngIf="![cardTypeSaved, pazePaymentType].includes(option.value)"
                    link="true"
                    styleClass="align-items-start justify-content-start"
                    (click)="option.value === cardTypeNew ? editCard() : editBankAccount()"
                    data-auto-id="edit-payment-option-button"
                >
                    <i class="pi pi-pen-to-square mobile-view"></i>
                    <span class="web-view underline">Edit</span>
                </p-button>
            </div>
            <div
                class="flex flex-row flex-wrap justify-content-between"
                *ngIf="paymentOptionsForm.controls['paymentOption'].value === pazePaymentType && option.value === pazePaymentType"
            >
                <p data-auto-id="paze-help-message">{{ pazePaymentReceived ? 'Payment method received. Agree to the terms below and checkout.' 
                    : 'Click on the paze button to open a modal then pick a payment option.' }}</p>
                <button 
                    type="button"
                    (click)="callPaze()"
                    class="m-0 p-0 border-none bg-transparent cursor-pointer"
                    data-auto-id="paze-button"
                    [disabled]="!pazeSdk"
                    aria-labelledby="paze-button"
                >
                    <img 
                        src="./assets/logos/paze_logo.png"
                        alt="Paze logo"
                        style="width: 100px; height: 35px;"
                    />
                </button>
            </div>
        </p-card>
    </ng-container>
</ng-container>

